import React from "react";
import image1 from "../images/success-01.jpg";
import image2 from "../images/success-02.jpg";
import image3 from "../images/success-3.jpg";
import image4 from "../images/success-4.jpg";
import image5 from "../images/success-05.jpg";

const AmplifySuccess = () => {
  return (
    <section class="my-5 px-5">
      <h3>Amplify Your Success</h3>
      <div className="success-images">
        <img src={image1} />
        <img src={image2} />
        <img src={image3} />
        <img src={image4} />
        <img src={image5} />
      </div>
    </section>
  );
};

export default AmplifySuccess;
